export default "/_next/static/images/leash-2x-e6ac3030ceb3cace351c01368522213f.jpg";